import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link, useNavigate } from "react-router-dom";
import "./ProfilePage.css";

const ProfilePage = () => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUser = localStorage.getItem("paidUser");
    if (storedUser) {
      const parsedUser = JSON.parse(storedUser);
      setUser(parsedUser);

      axios
        .get(`${process.env.REACT_APP_API_URL}/api/user/account?email=${parsedUser.email}`)
        .then((res) => {
          setUser((prev) => ({ ...prev, ...res.data }));
        })
        .catch((err) => {
          console.error("Failed to fetch user details:", err);
        });
    }
  }, []);

  const handleLogout = () => {
    if (window.confirm("Are you sure you want to log out?")) {
      localStorage.removeItem("paidUser");
      navigate("/login");
    }
  };

  const handleUpgrade = async () => {
    try {
      const res = await axios.put("${process.env.REACT_APP_API_URL}/api/user/account/upgrade", {
        email: user.email,
        newPlan: "Pro",
      });
      setUser((prev) => ({ ...prev, plan: res.data.plan }));
      alert("✅ Plan upgraded to Pro!");
    } catch (err) {
      console.error("Upgrade failed:", err);
      alert("❌ Failed to upgrade");
    }
  };

  if (!user)
    return (
      <div className="profile-container">
        <p>Loading user info...</p>
      </div>
    );

  return (
    <>
      {/* Header Navigation */}
      <header className="profile-header">
        <div className="header-left">
          <h3>NitinShukla</h3>
        </div>
        <nav className="header-nav">
          <Link to="/dashboard">Dashboard</Link>
          <Link to="/profile" className="active">Profile</Link>
          <button onClick={handleLogout} className="btn btn-sm btn-danger">Logout</button>
        </nav>
      </header>

      {/* Profile Info */}
      <div className="profile-container">
        <div className="profile-card">
          <h2>👤 Profile</h2>
          <p><strong>Name:</strong> {user.name || "N/A"}</p>
          <p><strong>Email:</strong> {user.email}</p>
          <p><strong>Role:</strong> {user.role || "user"}</p>

          {user.role === "user" && (
            <>
              <p><strong>Current Plan:</strong> {user.plan || "Basic"}</p>
              <button className="upgrade-btn" onClick={handleUpgrade}>
                Upgrade to Pro
              </button>
            </>
          )}

          {user.role === "creator" && (
            <>
              <p><strong>Status:</strong> Creator Dashboard Active</p>
              {/* Optional: Add video stats here */}
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default ProfilePage;
